import React, { useEffect, createElement } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Immutable from 'immutable'
import Content from '../../../layout/Content'
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes'
import { DEFAULT_PAGE_SIZE, LEGAL_SOURCE_SYSTEM } from '../../../../config/constants'
import Table from '../../../common/Table'
import LegalManifestCargoForm from '../legal-cargo/LegalManifestCargoForm'
import { clearItineraries, getItinerariesForLegal } from '../../../../actions'
import { INT_DATE_FORMAT } from '../../../../config/locale'
import { tzNormalizeDate } from '../../../../utils/date'
import { generateLegalManifestBaggageColumns } from '../../../../config/columns'

import LegalManifestBaggagesDetail from './LegalManifestBaggagesDetail'
import { generateManifestBaggageFile } from '../../../../actions/legal/LegalManifestBaggage'

const LegalManifestBaggages = ({
  breadcrumbs,
  loading,
  itineraries,
  dispatchGetItinerariesForLegal,
  dispatchClearItinerary,
  dispatchGenerateManifestBaggageFile
}) => {

  useEffect(() => () => dispatchClearItinerary(), []);

  const handleSubmit = (formValues) => {
    const { fromDateString, toDateString, busLicensePlate } = formValues;
    const startDate = tzNormalizeDate({
      date: fromDateString,
      format: INT_DATE_FORMAT,
    });
    const endDate = tzNormalizeDate({
      date: toDateString,
      format: INT_DATE_FORMAT,
    });

    const newFormValues = {
      licensePlate: busLicensePlate,
      startDate,
      endDate,
    };

    if (formValues.sourceCity) {
      newFormValues.sourceCityId = formValues.sourceCity.value;
    }

    if (formValues.destinationCity) {
      newFormValues.destinationCityId = formValues.destinationCity.value;
    }

    dispatchGetItinerariesForLegal(newFormValues);
  }

  const handleAction = (value) => {
    const { idSourceSystem, id: itineraryId, serviceTypeName } = value
    const sourceSystem = idSourceSystem.split('-')[0];
    if (sourceSystem === LEGAL_SOURCE_SYSTEM.FLIT.value) {
      return dispatchGenerateManifestBaggageFile({ itineraryId, serviceTypeName });
    }
    return ""
  }

  const renderManifestDetailComponent = ({ original }) => {
    const component = createElement(LegalManifestBaggagesDetail, { ...original });
    return (
      <div className="mt-3 mb-2 ml-5 mr-5">
        {component}
      </div>
    )
  }

  const content = (
    <>
      <LegalManifestCargoForm onSubmit={handleSubmit} loading={loading} />
      <h3>Resultados de la búsqueda</h3>
      <Table
        manual={false}
        columns={generateLegalManifestBaggageColumns(handleAction)}
        data={itineraries}
        defaultPageSize={DEFAULT_PAGE_SIZE}
        rowComponent={renderManifestDetailComponent}
        loading={loading}
      />
    </>
  )
  return (
    <Content
      title="Manifiesto de Equipaje"
      breadcrumbs={breadcrumbs}
      content={content}
    />
  )
}

LegalManifestBaggages.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  loading: PropTypes.bool,
  itineraries: PropTypes.instanceOf(Immutable.List).isRequired,
  dispatchGetItinerariesForLegal: PropTypes.func.isRequired,
  dispatchClearItinerary: PropTypes.func.isRequired,
  dispatchGenerateManifestBaggageFile: PropTypes.func.isRequired,
}

LegalManifestBaggages.defaultProps = {
  loading: false,
};

const mapStateToProps = ({ LegalUnit, ItineraryUnit }) => ({
  breadcrumbs: [
    ...LegalUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Manifiesto de Equipaje',
      href: '',
    },
  ],
  itineraries: ItineraryUnit.Itinerary.getIn(['all', 'content']).get('content', Immutable.List()),
  loading: ItineraryUnit.Itinerary.getIn(['all', 'loading']),
})

const mapDispatchToProps = {
  dispatchGetItinerariesForLegal: getItinerariesForLegal,
  dispatchClearItinerary: clearItineraries,
  dispatchGenerateManifestBaggageFile: generateManifestBaggageFile
}

export default connect(mapStateToProps, mapDispatchToProps)(LegalManifestBaggages)
